import { Controller, useFormContext } from 'react-hook-form';
import { noop } from 'lodash';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import NgpField from './NgpField';
import NgpFieldHelpTip from './NgpFieldHelpTip';

export default function NgpToggle({ fieldName, label, helpTipText, disabled, inverted, onChangeFunc = noop }) {
    const { control, errors } = useFormContext();

    return (
        <NgpField errors={errors} fieldName={fieldName}>
            <Controller
                control={control}
                name={fieldName}
                render={({ value = false, onChange }) => (
                    <FormControlLabel
                        control={
                            <Switch
                                onChange={(e) => {
                                    const checked = inverted ? !e.target.checked : e.target.checked;
                                    onChange(checked);
                                    onChangeFunc(e, checked);
                                }}
                                disabled={disabled}
                                checked={inverted ? !value : value}
                            />
                        }
                        label={label}
                    />
                )}
            />
            {helpTipText && <NgpFieldHelpTip isToggleField helpText={helpTipText} />}
        </NgpField>
    );
}
